import Http from '../API'

const esim_profile = {
  state: {
    group_esim_profile: [],
    group_esim_profile_tree: [],
    esim_profile_list: {},
    esim_profile_data: {},
    list_change_esim_profile: false,
    esim_profile_filter: { mno: [], msisdn:[], iccid: [], imsi:[], status: []},
    esim_profile_list_checked: {},
  },
  getters: {
    getEsimProfileGroups: (state) => {
      return state.group_esim_profile
    },
    getEsimProfileGroupsTree: (state) => {
      return state.group_esim_profile_tree
    },
    getEsimProfileGroupById: (state) => (id, parent) => {
      for (let i in state.group_esim_profile) {
        if (+state.group_esim_profile[i].id === +id) {
          return state.group_esim_profile[i]
        }
      }
      if(!parent) {
        esim_profile.mutations.groupEsimProfileUpdate(state, [...state.group_esim_profile,  {'name': 'unknown', 'id': id, 'status': 'unknw', parent: -1 }])
      }
      return  state.group_esim_profile[state.group_esim_profile.length - 1]
    },
    getEsimProfileById: (state) => (id) => {
      if (state.esim_profile_data[id] && state.esim_profile_data[id].profile) {
        // if (state.esim_profile_data[id].profile.ts) {
          return state.esim_profile_data[id]
        // }
      } else {
        state.esim_profile_data[id] = { profile: null, stats: { ts_start: -1, data: null }, load: true }
        return state.esim_profile_data[id]
      }
    },
    getEsimProfileLink: (state) => (id) => {
      return !!state.esim_profile_list[id];
    },
    getEsimProfileLinks: (state) => {
      return state.esim_profile_list
    },
    getEsimProfileListChange: (state) => {
      return state.list_change_esim_profile
    },
  },
  mutations: {

    groupEsimProfileUpdate (state, groups_esim_profile) {
      state.group_esim_profile = groups_esim_profile
      let group = {}
      let id = 0
      for(let i in state.group_esim_profile) {
        group[state.group_esim_profile[i].id] = { ...state.group_esim_profile[i], label: state.group_esim_profile[i].name,  expanded: true }
      }

      for(let i in state.group_esim_profile) {
        id = state.group_esim_profile[i].id
        if(state.group_esim_profile[i].parent !== -1) {

          if(group[state.group_esim_profile[i].parent] === undefined ||  group[state.group_esim_profile[i].parent].status === 'unknw') {
            group[id].parent = -1
          }
           else {
            if(group[state.group_esim_profile[i].parent].children === undefined) {
              group[state.group_esim_profile[i].parent].children = [];
            }
            group[state.group_esim_profile[i].parent].children.push(group[id]);
          }
        }
      }

      let root_group  = []

      for(let i in group) {
        if(group[i].parent === -1 && group[i].status !== 'unknw') {
          root_group.push(group[i])
        }
      }

      state.group_esim_profile_tree = root_group
    },

    setEsimProfileFilter (state, filter) {
      if (filter === null) {
        return false
      }
      state.esim_profile_filter = filter
    },

    addLinkGroupEsimProfile (state, id) {
      if (state.esim_profile_list[id] === undefined ) {
         state.esim_profile_list[id] = {}
      }
      state.esim_profile_list = {...state.esim_profile_list}
    },

    deleteLinkEsimProfile(state, link) {
      if (state.esim_profile_list[link.id] !== undefined && state.esim_profile_list[link.id]) {
        for (let i in state.group_esim_profile) {
          if (+state.group_esim_profile[i].id === +link.id ) {
            if (+state.group_esim_profile[i].parent !== -1 ) {
              state.esim_list[state.group_esim_profile[i].parent] = {}
            }
            break;
          }
        }

        delete state.esim_profile_list[link.id]
      }
      state.esim_profile_list = {...state.esim_profile_list}
    },

    deleteLinkGroupEsimProfile (state, params) {

      for( let id of params.ids ) {
        if (state.esim_profile_list[id] !== undefined ) {
          delete state.esim_profile_list[id]
        }
      }
      if(params.parent !== undefined && +params.parent !== -1) {
        state.esim_profile_list[params.parent] = {}
      }

      state.esim_profile_list = {...state.esim_profile_list}
    },

    updateEsimProfileProfile (state, esim_profile) {

      let oldEsimProfile = state.esim_profile_data[esim_profile.data.id] ? state.esim_profile_data[esim_profile.data.id] : state.esim_profile_data[esim_profile.data.virtual_imsi] ? state.esim_profile_data[esim_profile.data.virtual_imsi] : state.esim_profile_data[esim_profile.data.imsi]
      let tmp = {...esim_profile}
      delete tmp['ts']
      oldEsimProfile['hash'] = JSON.stringify(tmp)
      oldEsimProfile['profile'] = {...esim_profile.data}
      oldEsimProfile['load'] = false
      state.esim_profile_data = {...state.esim_profile_data}

      let name = ''
      if (name.trim() === '') {
        name = esim_profile.data.msisdn
      }
      state.esim_profile_list[esim_profile.data.id] = {
        name: name,
        icon: 'mdi-subdirectory-arrow-right',
        path: '/esim_profile/' + esim_profile.data.id
      }
      state.esim_profile_list = {...state.esim_profile_list}
    },
    setNotExistEsimProfile (state, id) {
      let oldEsimProfile = state.esim_profile_data[id]
      oldEsimProfile.load = false
      state.esim_profile_data = {...state.esim_profile_data}
    },
    updateEsimProfileSection (state, esim_profile) {
      if (state.esim_profile_data[esim_profile.id] === undefined) {
        state.esim_profile_data[esim_profile.id] = esim_profile
      }
      state.esim_profile_data[esim_profile.id]['section'] = esim_profile.section
    },
    updateEsimProfileStats (state, esim_profile) {
      let oldEsimProfile = state.esim_profile_data[esim_profile.id]
      oldEsimProfile['stats'] = {...esim_profile}
      state.esim_profile_data = {...state.esim_profile_data}
    },
    setEsimProfileListChange (state, status) {
      state.list_change_esim_profile = status
    },

    clearEsimProfile (state) {
      state.esim_profile_list = {}
      state.esim_profile_filter = { mno: [], msisdn:[], iccid: [], imsi:[], status: []}
      state.esim_profile_list_checked = {}
    },
  },

  actions: {

    deleteLinkEsimProfile (context, id) {
      context.commit('deleteLinkEsimProfile', id)
    },

    addLinkGroupEsimProfile (context, id) {
      context.commit('addLinkGroupEsimProfile', id)
    },
    deleteLinkGroupEsimProfile (context, params) {
      context.commit('deleteLinkGroupEsimProfile', params)
    },
    groupEsimProfileUpdate () {
      Http.simcard.getEsimsGroups((response) => {
        this.commit('groupEsimProfileUpdate', response.data)
      })
    },
    setEsimProfileFilter (context, filter) {
      context.commit('setEsimProfileFilter', filter)
    },
    updateEsimProfileProfile (_, id) {
      Http.simcard.getEsimProfile(id, (response) => {
        this.commit('updateEsimProfileProfile', { ts: Date.now() + 60000, ...response })
      }, () => { this.commit('setNotExistEsimProfile',  id) })
    },
    updateEsimProfileSection (_, params) {
      this.commit('updateEsimProfileSection', { id: params.id, section: params.section })
    },
    updateEsimProfileStats (state, id, tsStart, tsEnd) {
      Http.simcard.getEsimStats(id, tsStart, tsEnd, (response) => {
        this.commit('updateEsimProfileStats', {id: id, ts_start: tsStart, ts_end: tsEnd, data: {...response.data}})
      })
      return false
    }
  }
}

export default esim_profile
